import AhanHeadshot from "../Media/AhanHeadshot.jpg";
import BenjaminHeadshot from "../Media/BenjaminHeadshot.png";

export const EthiopiaBoard = [
    {
        id: "ahan",
        name: "Ahan",
        image: AhanHeadshot,
        description: "4th year",
        major: "Mechanical Engineering",
    },
    {
        id: "benjamin",
        name: "Benjamin",
        image: BenjaminHeadshot,
        description: "4th year",
        major: "Mechanical Engineering",
    },
]